import type { MouseEvent } from "react"
import { useMemo } from "react"

import {
  PaymentMethodNameEnum,
  StatusTrackingEnum,
} from "@/enums"
import { useDownloadCancellationLetter } from "@/hooks"

import DownloadButton from "../commons/download-button"
interface ExportCancelLetterProps {
  data?: OrderByIdResponseType
}
export const ExportCancelLetter = ({
  data,
}: ExportCancelLetterProps) => {
  const { handleDownload, isDownloading } =
    useDownloadCancellationLetter({
      orderId: data?.id,
    })
  const lastStatus =
    data &&
    data?.events &&
    data.events[data?.events?.length - 1].status
  const hasCreditCardPayment = useMemo(() => {
    return data?.transactions?.some((transactionMethod) => {
      return (
        transactionMethod.method ===
        PaymentMethodNameEnum.CREDIT_CARD
      )
    })
  }, [data?.transactions])
  const isCreditPointsPayment = useMemo(() => {
    return data?.transactions?.some((transactionMethod) => {
      if (
        transactionMethod.method ===
        PaymentMethodNameEnum.LOYALTY_POINTS
      ) {
        return true
      }
      if (
        transactionMethod.method ===
        PaymentMethodNameEnum.CREDIT_CARD
      ) {
        return true
      }
      return false
    })
  }, [data?.transactions])
  const downloadButtonText = `Carta de cancelamento ${
    isCreditPointsPayment ? " (Cartão)" : " (PDF)"
  }`
  const tooltipText =
    "Carta de cancelamento não pode ser emitida para este status, pois não houve cancelamento de transação (Cartão)."
  const showButton =
    lastStatus === StatusTrackingEnum.CANCELED_BY_STORE &&
    hasCreditCardPayment
  type HandlePropagationClickType = {
    event: MouseEvent
    callback: VoidFunction
  }
  const handlePropagationClick = ({
    event,
    callback,
  }: HandlePropagationClickType) => {
    event.stopPropagation()
    callback()
  }
  return (
    <DownloadButton
      variant="destructive"
      size="sm"
      isDownloading={isDownloading}
      tooltipText={tooltipText}
      disabled={!showButton}
      onClickCapture={(event) => {
        handlePropagationClick({
          event,
          callback: () => handleDownload(),
        })
      }}
    >
      {downloadButtonText}
    </DownloadButton>
  )
}
